import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { McatalogConfigService } from 'src/app/services/catalogs-services/config-services/mcatalog-config.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-catalogs-config-inactivity-time-card',
  templateUrl: './catalogs-config-inactivity-time-card.component.html',
  styleUrls: ['./catalogs-config-inactivity-time-card.component.scss']
})
export class CatalogsConfigInactivityTimeCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() inactivityTime;
  updateMCatalogInactivityTimeSubscription: Subscription;

  basicDataForm = new FormGroup({
    inactivityTime: new FormControl(null, Validators.required)
  });

  constructor(private mcatalogConfigService: McatalogConfigService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.inactivityTime) {
      this.resetForm();
    }
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      inactivityTime: this.inactivityTime
    });
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateMCatalogInactivityTimeSubscription = this.mcatalogConfigService.updateMCatalogInactivityTime(this.basicDataForm.get('inactivityTime').value).subscribe(
        (res) => {
          this.snackbarService.open(res['message'], 'success');
        },
        (error) => {
          this.snackbarService.open(error['message'], 'error');
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public inputChange() {
    if (this.basicDataForm.get('inactivityTime').dirty) {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
        this.resetForm();
      }
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('inactivityTime').valid || !(this.basicDataForm.get('inactivityTime').value > 0)) {
      return 'catalogs-page.snackbar messages.inactivity time error';
    } else {
      return true;
    }
  }

  ngOnDestroy() {
    if (this.updateMCatalogInactivityTimeSubscription) { this.updateMCatalogInactivityTimeSubscription.unsubscribe(); }
  }
}
